import Main from "./Main.js";
import Scene from "./Scene.js";
export default class Wyt {

	constructor(hs, parms, callback) {
		this.hs = hs;
		this.parms = parms;
		this.callback = callback;
	}


	init() {
		Main.debugTrace("Hotspot Wyt: " + this.hs.name);
		// apre il layer con l'iframe
		let mc = jQuery("#template-trix-iframe").clone();
		mc.attr("id", "ifrax" + Wyt.ENUM++);
		jQuery(".js-trix1010").append(mc);
		jQuery(".js-close-frame", mc).on("click", jQuery.proxy(this.closeFrame, this));
		this.mc = mc;
		this.dispatch({
			type: Main.HS_EVENT_HIDE_INTERFACE
		});
		this.createYt();
		//Main.setUrl(Scene.getCurrentScene().name, this.hs.Uid, null)
	}

	closeFrame(e) {
		this.mc.remove();
		this.dispatch({
			type: Main.HS_EVENT_SHOW_INTERFACE
		});
		//Main.setUrl(Scene.getCurrentScene().name, null, null);
	}

	dispatch(e) {
		this.callback.call(null, e);
	}

	createYt(e) {

		let iframe = jQuery("<iframe class='trix-iframe-dim' width='100%' height='100%' src='' frameborder='0' allowfullscreen></iframe");
		iframe.attr("id", "ifrm" + Wyt.ENUM++);
		iframe.addClass("to-remove");
		jQuery(".to-remove", jQuery(".js-trix-content")).remove();
		jQuery(".js-trix-content", this.mc).append(iframe);
		var code = this.hs.InfoJson.iframe_url.match("[\\?&]v=([^&#]*)")[1];
		let sy = Main.getYoutubeString(code)
		iframe.attr("src", sy);
		//console.log(iframe.attr("src"));
		this.iframe = iframe;
	}
}

Wyt.ENUM = 0;